import { render, staticRenderFns } from "./StatusPayment.vue?vue&type=template&id=000b345e"
import script from "./StatusPayment.vue?vue&type=script&lang=js"
export * from "./StatusPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports